import { View, Text, Pressable, ScrollView, ImageBackground } from 'react-native'
import React, { useLayoutEffect, useState } from 'react'
import GlobalStyles from './../style';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useNavigation } from '@react-navigation/native';
import { useSelector } from 'react-redux'
import dr from './../datosReferenciales.json'
import transl from './../translations/transl'

let lang = undefined;

const FriendsList = () => {
  const navigation = useNavigation();

  useLayoutEffect(() => {
      navigation.setOptions({headerTitle: transl('MainMenu.lista', lang)})
  }, []);

  //receivedData
  const [value, setvalue] = useState('');
  const readValue = () => {
    AsyncStorage.getItem('equipos')
    .then((value)=> {
      setvalue(value)
      loadFriends(value,navigation)
    })
  }
  readValue();

  lang = dr.idiomas[useSelector((state) => state.language)].value

  return (
    <View style={{flex:1}}>
      <ImageBackground source={require('./../img/background4.png')} resizeMode="cover" style={{flex:1}}>
        {loadFriends(value,navigation)}
      </ImageBackground>
    </View>
  )
}

function loadFriends (data,navigation) {
  if(data === undefined || !data) return <Text>loading...</Text>
  if(typeof data != "object") data = data != null ? JSON.parse(data) : null

  let allFriends = []
  for(let i = 0; i < data.multiplayer.teams.length; i++){
    const myDate = new Date(data.multiplayer.teams[i].info.date);
    allFriends.push(<Pressable key={i} onPress={() => {navigation.navigate('FriendProfile', {team: data.multiplayer.teams[i]})}} style={GlobalStyles.cardHalfScreenPressable}><View >
        <Text style={{textAlign:'center',marginBottom:25}}>{transl('FriendsList.nombre', lang, [data.multiplayer.teams[i].info.name])}</Text>
        <Text style={{textAlign:'center',marginBottom:25}}>{transl('FriendsList.equipo', lang, [data.multiplayer.teams[i].info.teamName])}</Text>
        <Text style={{textAlign:'center',marginBottom:25}}>{transl('FriendsList.media', lang, [calculaMediaEquipo(data.multiplayer.teams[i])])}</Text>
        <Text style={{textAlign:'center',marginBottom:25}}>{transl('FriendsList.añadido', lang, [myDate.getDate(),myDate.getMonth()+1,myDate.getFullYear()])}</Text>
      </View></Pressable>);
  }

  if(data.multiplayer.teams.length == 0) return <ScrollView contentContainerStyle={{ flex: 1, justifyContent: 'center' }}><Text style={{textAlign:'center',fontSize:20,marginTop: 'auto', marginBottom: 'auto'}}>No hay amigos añadidios</Text></ScrollView>;
  return <ScrollView>{allFriends}</ScrollView>
}

function calculaMediaEquipo(theTeam){
  let totalSkillsSum = 0;
  for (let j = 0; j < 7; j++) {
    let thisPlayerSkills = 0;
    thisPlayerSkills += Number(theTeam.players[j].skills.reduce((partialSum, a) => partialSum + a, 0))
    thisPlayerSkills += Number(theTeam.players[j].broom.reduce((partialSum, a) => partialSum + a, 0))
    totalSkillsSum += Number(thisPlayerSkills/9)
  }
  return Number(totalSkillsSum/7).toFixed(2)
}

export default FriendsList